import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../store';
import ConfigService from '../../../api/services/ConfigService';

interface ConfigValuesState {
  data: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: ConfigValuesState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchConfigValuesThunk = createAsyncThunk(
  'configValues/fetch',
  async (serviceType: string, { rejectWithValue }) => {
    try {
      const configValues = await ConfigService.getConfigValues(serviceType);
      return configValues;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch config values');
    }
  },
);

const configValuesSlice = createSlice({
  name: 'configValues',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchConfigValuesThunk.pending, (state: any) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchConfigValuesThunk.fulfilled, (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchConfigValuesThunk.rejected, (state: any, action: { payload: string }) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const selectConfigValues = (state: RootState) => state.configValuesSlice;

export default configValuesSlice.reducer;
